export default __webpack_public_path__ + "709c4a04c43066332bd70478c6a18f38.svg";